@charset "UTF-8";

/* app/js/src/components/clipping-studio/right-sidebar/clipping-studio-right-sidebar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.tab-content::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tab-content::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.tab-content::-webkit-scrollbar-corner {
  background: transparent;
}
.tab-content::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.tab-content::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tab-content::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.tab-content::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.tab-content::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.right-sidebar {
  width: 340px;
  min-width: 340px;
  flex-shrink: 0;
  height: 100%;
  background: rgb(255, 255, 255);
  border-left: 1px solid rgb(226, 232, 241);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  z-index: 30;
}
.tabs-header {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  padding: 12px 8px 10px 12px;
  gap: 4px;
}
.tabs-header .tabs-steps {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}
.tabs-header .tabs-steps__connector {
  flex-shrink: 0;
  width: 14px;
  height: 1px;
  margin-top: calc(28px / 2);
  background: rgb(226, 232, 241);
  transition: background 0.18s ease;
}
.tabs-header .tab-step {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 62px;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  color: rgba(0, 0, 0, 0.54);
  cursor: default;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  transition: color 0.18s ease;
}
.tabs-header .tab-step.active {
  color: rgb(45, 187, 252);
}
.tabs-header .tab-step.active .tab-step__circle {
  border-color: rgb(45, 187, 252);
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.tabs-header .tab-step.active .tab-step__label {
  color: rgb(45, 187, 252);
}
.tabs-header .tab-step.completed {
  color: rgb(45, 187, 252);
}
.tabs-header .tab-step.completed .tab-step__circle {
  border-color: rgb(45, 187, 252);
  background: rgb(255, 255, 255);
  color: rgb(45, 187, 252);
}
.tabs-header .tab-step.completed .tab-step__label {
  color: rgb(45, 187, 252);
}
.tabs-header .tab-step.completed + .tabs-steps__connector {
  background: rgb(45, 187, 252);
}
.tabs-header .tab-step__circle {
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: rgba(0, 0, 0, 0.54);
  transition:
    color 0.18s ease,
    border-color 0.18s ease,
    background 0.18s ease;
}
.tabs-header .tab-step__check {
  display: block;
  flex-shrink: 0;
}
.tabs-header .tab-step__label {
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  transition: color 0.18s ease;
}
.tabs-header .close-btn {
  flex-shrink: 0;
  padding: 4px;
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.54);
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.tabs-header .close-btn:hover {
  color: rgba(0, 0, 0, 0.85);
  background: rgba(0, 0, 0, 0.04);
}
.tabs-header .close-btn .chevrons-left {
  display: block;
  transform: scaleX(-1);
}
.tab-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.tab-content evrideo-clipping-studio-destination-tab,
.tab-content evrideo-clipping-studio-metadata-tab,
.tab-content evrideo-clipping-studio-thumbnail-tab,
.tab-content evrideo-clipping-studio-publish-tab {
  display: block;
  height: 100%;
}
.right-sidebar__footer {
  padding: 1rem;
  border-top: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.right-sidebar__footer-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}
.right-sidebar__footer-error {
  padding: 12px 0;
}
.right-sidebar__footer-error-text {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.right-sidebar__tiktok-declaration {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.54);
}
.right-sidebar__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
  outline: none;
}
.right-sidebar__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.right-sidebar__btn--primary {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
}
.right-sidebar__btn--primary:hover:not(:disabled) {
  background: rgb(41, 170, 229);
}
.right-sidebar__btn--secondary {
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  border-color: rgb(226, 232, 241);
}
.right-sidebar__btn--secondary:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
}
.right-sidebar__btn--row-back {
  flex: 0 0 calc((100% - 8px) / 3);
  width: auto;
  min-width: 0;
}
.right-sidebar__btn--row-next {
  flex: 0 0 calc((100% - 8px) * 2 / 3);
  width: auto;
  min-width: 0;
}
.right-sidebar__btn-icon {
  flex-shrink: 0;
}
/*# sourceMappingURL=clipping-studio-right-sidebar.component.css.map */
